import { Injectable, inject } from '@angular/core';
import { Endpoint } from '../constants/endpoint';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IrrigationOfficeResponseModel } from '@roi/common/models/irrigation-office.model';
import { MenuResponseModel } from '@roi/common/models/menu.model';
import {
  DistrictsResponseModel,
  ProvinceResponseModel,
  SubDistrictsResponseModel,
} from '@roi/common/models/province.model';
import { StatusResponseModel } from '@roi/common/models/water-allocation-status.model';

@Injectable({ providedIn: 'root' })
export class MasterFetch {
  private http = inject(HttpClient);

  public irrigationOffices(): Observable<IrrigationOfficeResponseModel> {
    return this.http.get<IrrigationOfficeResponseModel>(
      `${Endpoint.Master}/irrigationOffices`
    );
  }
  public menus(): Observable<MenuResponseModel> {
    return this.http.get<MenuResponseModel>(`${Endpoint.Master}/menu`);
  }
  public provinces(): Observable<ProvinceResponseModel> {
    return this.http.get<ProvinceResponseModel>(`${Endpoint.Master}/provinces`);
  }
  public districts(provinceId: number): Observable<DistrictsResponseModel> {
    return this.http.get<DistrictsResponseModel>(
      `${Endpoint.Master}/districts/${provinceId}`
    );
  }
  public subDistricts(
    districtId: number
  ): Observable<SubDistrictsResponseModel> {
    return this.http.get<SubDistrictsResponseModel>(
      `${Endpoint.Master}/sub-districts/${districtId}`
    );
  }
  public getWaterStatus(): Observable<StatusResponseModel> {
    return this.http.get<StatusResponseModel>(`${Endpoint.Status}`);
  }
}
